export const loadImage = (file: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      typeof reader.result === 'string' ? resolve(reader.result) : reject(reader.result);
    };
    reader.onerror = (error) => reject(error);
  });
